import { kebabCase } from 'lodash';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { SelectFilterOperationType, valueFromString, valueToString } from './select';
import { TermSeparator } from './separators';
const isValid = (filter)=>{
    switch(filter.type){
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
            return filter.value != null;
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value;
            return ((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []).length > 0;
        default:
            return true;
    }
};
const to = valueToString((x)=>x.toString());
const from = valueFromString((value)=>{
    const result = parseInt(value, 10);
    // NOTE:: for inferredProgress the value will be string and we need to return the string.
    // Don't convert strings like `1 String` to 1. So added Number.isNaN(Number(value))
    return Number.isNaN(result) || Number.isNaN(Number(value)) ? value : result;
});
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return type;
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
            return [
                type,
                to(filter.value == null ? [] : [
                    filter.value
                ])
            ].join(TermSeparator);
        case SelectFilterOperationType.IsNoneOf:
        case SelectFilterOperationType.IsOneOf:
            var _filter_value;
            return [
                type,
                to((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : [])
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
            var _from;
            return {
                field,
                type,
                value: ((_from = from(meta)) !== null && _from !== void 0 ? _from : [])[0]
            };
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            return {
                field,
                type,
                value: from(meta)
            };
        default:
            return unreachable(type);
    }
};
export const SingleSelectFieldFilter = {
    isValid,
    toString,
    parse
};
